import { render } from "./ScheduledProcedures.vue?vue&type=template&id=4b0cdd1c"
import script from "./ScheduledProcedures.vue?vue&type=script&lang=js"
export * from "./ScheduledProcedures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__